import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Formik, Form, ErrorMessage, Field } from "formik";
import AddUser from "./AddUser";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const schema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  gender: yup.string().required(),
  driverScince: yup.string().required(),
  vehicleId: yup.string().required(),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required(),
});

const EditUser = () => {
  const params = useParams();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [userGroupId, setUserGroupId] = useState("");
  const [msg, setMsg] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [status, setStatus] = useState();

  const [userGroups, setUserGroups] = useState([]);
  const history = useNavigate();
  const [token, setToken] = useState("");
  const [expire, setExpire] = useState("");

  const initialValues = {
    firstName: "",
    lastName: "",
    gender: "",
    driverScince: "",
    vehicleId: "",
    phoneNumber: "",
  };
  const getUser = async () => {
    axios
      .get("/user/" + params.id, {
        // headers: {
        //   Authorization: `Bearer ${this.token}`,
        // },
      })
      .then((res) => {
        console.log(res.data);
        setFirstName(res.data.user.name);

        setPhoneNumber(res.data.user.phoneNumber);

        setGender(res.data.user.gender);
        setEmail(res.data.user.email);
        setAddress(res.data.user.address);
        setStatus(res.data.user.status);
        setSelectedImage(res.data.user.profilePicture);
        setUserGroupId(res.data.user.roleId);
      });
  };

  const editUser = async (e) => {
    //  e.preventDefault();

    try {
      var bodyFormData = new FormData();
      bodyFormData.append("id", params.id);
      bodyFormData.append("name", firstName + " " + lastName);
      bodyFormData.append("phoneNumber", phoneNumber);
      bodyFormData.append("gender", gender);
      bodyFormData.append("userGroupId", userGroupId);
      bodyFormData.append("email", email);
      bodyFormData.append("status", status);

      bodyFormData.append("address", address);

      console.log(userGroupId);
      console.log("id...", params.id);
      const responce = await axios.post(
        "/users/" + params.id,
        bodyFormData
      );
      history("/users");
      console.log(responce.status);
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        setMsg(error.response.data.msg);
        alert(msg);
      }
    }
  };

  const refreshToken = async () => {
    try {
      const response = await axios.get("/token");
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setExpire(decoded.exp);
    } catch (error) {
      if (error.response) {
        history("/");
      }
    }
  };

  const getRoles = async () => {
    const response = await axios.get("/roles", {
      // headers: {
      //     Authorization: `Bearer ${token}`
      // }
    });
    console.log(response.data);
    setUserGroups(response.data);
  };

  useEffect(() => {
    getRoles();
    getUser();
    getUser();
    // refreshToken(); s
  }, []);

  return (
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>User Edit</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active">User Edit</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <Formik
          initialValues={initialValues}
          // validationSchema={schema}
          onSubmit={async (e) => {
            await editUser(e);
            //  ßresetForm();
          }}
        >
          <Form className="box">
            <div class="row">
              <div class="col-md-6">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">Basic Information</h3>

                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="form-group">
                      <label for="inputName">First Name</label>
                      <Field
                        type="text"
                        name="firstName"
                        value={firstName}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                        }}
                        // id="inputName"
                        class="form-control"
                      />
                    </div>
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="text-danger"
                    />

                    <div class="form-group">
                      <label for="inputName">Phone Number</label>
                      <Field
                        type="text"
                        id="inputName"
                        name="phoneNumber"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        class="form-control"
                      />
                    </div>
                    <ErrorMessage
                      name="phoneNumber"
                      component="div"
                      className="text-danger"
                    />
                    <div class="form-group">
                      <label for="inputName">Email</label>
                      <Field
                        type="email"
                        id="inputName"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        class="form-control"
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                    <div class="form-group">
                      <label for="inputName">Address</label>
                      <Field
                        type="text"
                        id="inputName"
                        name="address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        class="form-control"
                      />
                    </div>
                    <ErrorMessage
                      name="address"
                      component="div"
                      className="text-danger"
                    />
                    <div className="form-group">
                      <label for="inputStatus">Gender</label>
                      <select
                        id="inputStatus"
                        class="form-control custom-select"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option selected disabled>
                          Select Gender
                        </option>
                        <option value={"male"}>Male</option>
                        <option value={"female"}>Female</option>
                      </select>
                    </div>
                    <ErrorMessage
                      name="gender"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title">Additional Information</h3>

                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="form-group">
                      <label for="inputStatus">User Group</label>
                      <select
                        id="inputStatus"
                        class="form-control custom-select"
                        value={userGroupId}
                        onChange={(e) => {
                          setUserGroupId(e.target.value);
                          console.log(userGroupId);
                        }}
                      >
                        {" "}
                        <option value="" selected disabled>
                          Select User Groups
                        </option>
                        {userGroups.map((userGroup) => {
                          return (
                            <option key={userGroup.id} value={userGroup.id}>
                              {userGroup.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <ErrorMessage
                      name="vehicleId"
                      component="div"
                      className="text-danger"
                    />
                    <div className="form-group">
                      <label for="inputStatus">Status</label>
                      <select
                        id="inputStatus"
                        class="form-control custom-select"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option selected disabled>
                          Select Status
                        </option>
                        <option value={"Active"}>Active</option>
                        <option value={"Inactive"}>Inactive</option>
                      </select>
                    </div>
                    {/* <div class="form-group">
                      <label for="inputEstimatedBudget">
                        Driver Scince Year
                      </label>
                      <input
                        type="date"
                        id="inputEstimatedBudget"
                        class="form-control"
                        value={driverScince}
                        onChange={(e) => setDriverScince(e.target.value)}
                      />
                    </div> */}
                    <div class="form-group">
                      <label for="exampleInputFile">Profile Image</label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="exampleInputFile"
                            onChange={(e) =>
                              setSelectedImage(e.target.files[0])
                            }
                          />
                          <label
                            class="custom-file-label"
                            for="exampleInputFile"
                          >
                            Choose file
                          </label>
                        </div>
                        {/* <div class="input-group-append">
                          <span class="input-group-text">Upload</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input
                  type="submit"
                  value="Save Changes"
                  class="btn btn-success float-right"
                />
              </div>
            </div>
          </Form>
        </Formik>
      </section>
    </div>
  );
};

export default EditUser;
